import React from 'react'
import styled from 'styled-components'
import {translate} from 'i18n'
import {GiftShopRootScreen} from 'pages'
import {useLocation} from 'utils'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import GiftshopPackageActive from '../containers/GiftshopPackageActive'

const StyledOuterContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-top: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({theme}) => theme.white_2};
`

const StyledContainer = styled.div`
  width: calc(100% - ${convertUnit(40)});
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  max-width: ${convertUnit(561)};
  background-color: ${({theme}) => theme.white_1};
  border-radius: ${convertUnit(16)};
  max-height: ${convertUnit(657)};
  flex: 1;
  overflow: hidden;
`

const StyledNotice = styled.div`
  width: calc(100% - ${convertUnit(40)});
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${convertUnit(8)};
  background-color: ${({theme}) => theme.gray_1};
  border-radius: ${convertUnit(8)};
  margin-bottom: ${convertUnit(16)};
`

export default function GiftshopPackageActiveScreen() {
  const {sourceData} = useLocation('giftshop_package_active').state
  return (
    <GiftShopRootScreen
      headerTitle={translate('giftShop:packageActiveTitle')}
      showBadgeIcon
      showMessageIcon={false}>
      <StyledOuterContainer>
        <StyledContainer>
          <StyledNotice>
            <Icon color="black_1" type="cart" />
            <Paragraph color="black_1" fontWeight="medium">
              {translate('giftShop:packageActiveNotice')}
            </Paragraph>
          </StyledNotice>
          <GiftshopPackageActive data={sourceData} />
        </StyledContainer>
      </StyledOuterContainer>
    </GiftShopRootScreen>
  )
}
